module.exports = __webpack_public_path__ + "static/img/lunbo1.e5b5024a.webp";